var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"tooltip-container",on:{"mouseover":function($event){_vm.showTooltip = true},"mouseleave":function($event){_vm.showTooltip = false}}},[_vm._t("default"),_vm._v(" "),(_vm.showTooltip)?_c('div',{staticClass:"tooltip-content"},[_vm._t("tooltip")],2):_vm._e()],2)
}
var staticRenderFns = []

export { render, staticRenderFns }